<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
    y="0px" viewBox="0 0 1401 1524" xml:space="preserve">
    <path d="M0,0h1401v826c0,94.667-18.5,185-55.5,271s-86.667,160.167-149,222.5s-136.667,112-223,149S796.333,1524,701,1524 c-126.667,0-243.833-31.167-351.5-93.5S156.667,1283.333,94,1176S0,952,0,826V0z M158,150l543,985l542-985H864L701,447L537,150H158z M152,826c0,146,50.5,272,151.5,378S528,1366.667,674,1374L152,424V826z M727,1374c146-7.333,269.833-64,371.5-170 S1251,972,1251,826V424L727,1374z" />
  </svg>
</template>
